import { isIOS } from "./device/is-ios";

export const downloadPdf = (data) => {
    try {
        const fileURL = getPdfFileUrl(data);

        if (isIOS()) {
            openPdfIOS(fileURL);
            return;
        }

        if (!isIOS()) {
            openPdfAndroid(fileURL);
            return;
        }

    } catch (error) {
        window.captureException(error);
        alert(error);
    }
}

export const getPdfFileUrl = (data) => {
    try {
        var byteCharacters = atob(data);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        var file = new Blob([byteArray], { type: 'application/pdf;base64' });
        var fileURL = URL.createObjectURL(file);

        return fileURL;

    } catch (error) {
        window.captureException(error);
        alert(error);
    }
}

const openPdfIOS = (fileURL) => {
    const a = document.createElement('a');
    a.href = fileURL;
    const d = new Date();
    a.download = "denticalc-calculation-" + d.getTime() + ".pdf";
    a.click();
    window.URL.revokeObjectURL(fileURL);
}

const openPdfAndroid = (fileURL) => {
    window.open(fileURL);
    return;
}
